// ======================= AI RECOMMENDATION API =======================

import { apiCall } from "../base";
import { HttpMethod } from "@/types/https";
import { ENDPOINT } from "../endpoint";
import {
  AiRecommendationQueryParams,
  AiRecommendationResponse
} from "../types/ai-recommendation.type";

/**
 * Latest stored OR-AI solver run. Workchestra syncs runs from the AeroTrak PPS API (or its mock,
 * per `PpsAiRecommendation` app settings) on a cron schedule; this call never reaches Dataiku.
 */
export const GetAiRecommendationSchedules = (
  params: AiRecommendationQueryParams
) => ({
  name: `AiRecommendation_${params.workspaceId}_${params.from || ""}_${params.to || ""}_${params.search || ""}_${params.filters || ""}_${params.sorts || ""}_${params.jobOrder || ""}`,
  handle: async (): Promise<AiRecommendationResponse> => {
    return apiCall<AiRecommendationResponse>({
      url: ENDPOINT.AI_RECOMMENDATION_SCHEDULES,
      method: HttpMethod.GET,
      params
    });
  }
});
